import { render, staticRenderFns } from "./spacing.vue?vue&type=template&id=5560c462&scoped=true&"
import script from "./spacing.vue?vue&type=script&lang=js&"
export * from "./spacing.vue?vue&type=script&lang=js&"
import style0 from "./spacing.vue?vue&type=style&index=0&id=5560c462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560c462",
  null
  
)

export default component.exports